


















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import AlatBantu from "@/components/pemeriksaan/assesmen/AlatBantu.vue";
import Prothesa from "@/components/pemeriksaan/assesmen/Prothesa.vue";
import CacatTubuh from "@/components/pemeriksaan/assesmen/CacatTubuh.vue";
import ADL from "@/components/pemeriksaan/assesmen/ADL.vue";
import RisikoJatuh from "@/components/pemeriksaan/assesmen/RisikoJatuh.vue";
import TimeStamp from "@/components/pemeriksaan/assesmen/TimeStamp.vue";
import { userModule } from "@/store/modules/user";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";

@Component({
  components: {
    AlatBantu,
    Prothesa,
    CacatTubuh,
    ADL,
    RisikoJatuh,
    TimeStamp,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class Fungsional extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() fungsional!: object;
  @Prop() showRiwayat!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  sess_login = userModule.user;
  getparam = {
    reg: this.register,
    unit_id: this.sess_login.unit_id,
  };
  mounted() {}
  setAlatBantu(v) {
    this.fungsional["alat_bantu"] = v;
  }
  setProthesa(v) {
    this.fungsional["prothesa"] = v;
  }
  setCacatTubuh(v) {
    this.fungsional["cacat_tubuh"] = v;
  }
  setAdl(v) {
    this.fungsional["adl"] = v;
  }
  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  @Watch("fungsional")
  changeFungsional() {
    this.$emit("fungsional", this.fungsional);
  }
}
